export default __webpack_public_path__ + "static/media/me.dd6b4757.jpg";